import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const inputVariants = cva(
  'flex items-center w-full px-[2.62rem] min-h-[7.625rem] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[#858C94] disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      theme: {
        default:
          'p-normal text-[#858C94] font-[200] rounded-[2rem] focus:outline outline-1 outline-offset-[0.5rem] !border-[0.125rem] !border-[#e6e6e6] bg-[#f9f9f9]  before:-inset-[.5rem] before:rounded-[inherit] before:absolute before:border before:border-white !py-[1.5rem]',
        new: 'text-[2.25rem] min-h-[7rem] !outline-none bg-white/5 border border-white/20 focus:border-white/40 transition-all',
      },
    },
    defaultVariants: {
      theme: 'default',
    },
  }
);

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, theme, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ theme }), className)}
        style={
          theme === 'default'
            ? { outlineColor: 'rgba(255, 255, 255, 0.07)' }
            : undefined
        }
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
